import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
// import { ApiService, MockApiService, RestApiService } from '@web-nx-ng-tsc/web-shared-data-access';
import { environment } from '../environments/environment';
import { ApiService, MockApiService, RestApiService } from '@web-nx-ng-tsc/campaign-shared-data-access';
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAnimations(),
    provideClientHydration(),
    provideHttpClient(),
    {
      provide: ApiService,
      // useClass: RestApiService,
      useFactory: () => {
        if (environment.production) {
          return new RestApiService();
        } else {
          return new MockApiService();
        }
      },
    },
  ],
};
